import { Injectable } from '@angular/core';
import { AccessToApplicationTypeService } from './access-to-application-type.service';
import { isFunction } from '../utils/is-function';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';

interface IStateRule {
    AccessType: AccessRightType;
    SettingType: ApplicationSettingsType[];
}

@Injectable()
export class StateAccessCheckService {
    private accessMap: {
        [prop: string]: IStateRule[];
    } = {};

    private objectTypesMap: {
        [key: string]: number;
    } = {};

    constructor(private accessToApplicationTypeService: AccessToApplicationTypeService) {}

    registerStateRules(stateNames: string[], rules: IStateRule) {
        stateNames.forEach((value) => {
            if (!this.accessMap[value]) {
                this.accessMap[value] = [];
            }
            this.accessMap[value].push(rules);
        });
    }

    registerStateObjectType(stateNames: string[], objectType: number) {
        stateNames.forEach((stateName) => (this.objectTypesMap[stateName] = objectType));
    }

    getAccessMap() {
        return this.accessMap;
    }

    getAccessRulesForState(stateName: string) {
        return this.getAccessMap()[stateName];
    }

    getObjectTypeForState(stateName: string) {
        return this.objectTypesMap[stateName];
    }

    isStateAllowedForCurrentUser(stateName: string, params?) {
        let accessRules = this.getAccessRulesForState(stateName);
        if (accessRules) {
            if (!Array.isArray(accessRules)) {
                accessRules = [accessRules];
            }
            let result = false;
            accessRules.forEach((rule) => {
                if (isFunction(rule)) {
                    result = result || (<any>rule)(params);
                } else {
                    rule.SettingType.forEach((SettingType) => {
                        if (
                            !result &&
                            this.accessToApplicationTypeService.HasAccessToApplicationType(SettingType, rule.AccessType)
                        ) {
                            result = true;
                        }
                    });
                }
            });
            return result;
        }
        return true;
    }
}
